var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { ConfirmToolbar } from '../../common/Toolbar';
import { Body } from '../../root/PageRouter';
import Loading from '../../common/Loading';
import SecondaryToolbarTitle from '../../common/SecondaryToolbarTitle';
import regEx from '../../../utils/regex';
import { useUpdateOptionPlanMutation, useUpdateOptionPlanPageQuery, } from '../../../__generated__/graphql';
import { useParams } from 'react-router';
import { List, ListItemInput, ListItemCurrencyInput, } from '@bootstraplabs/bsw-common-react';
function Toolbar(props) {
    return (_jsxs(_Fragment, { children: [_jsx(ConfirmToolbar, __assign({ disabled: props.disabled, onClick: props.onClick }, { children: props.children }), void 0),
            _jsx(SecondaryToolbarTitle, { children: "Edit Option Plan" }, void 0)] }, void 0));
}
export default function UpdateOptionPlan() {
    // Router
    var optionPlanId = useParams().optionPlanId;
    var _a = useUpdateOptionPlanPageQuery({
        variables: { optionPlanId: optionPlanId },
    }), data = _a.data, loading = _a.loading;
    var optionPlan = data && data.optionPlan;
    // State
    var _b = useState(''), name = _b[0], setName = _b[1];
    var _c = useState(''), purchasePrice = _c[0], setPurchasePrice = _c[1];
    var _d = useState(''), exercisePrice = _d[0], setExercisePrice = _d[1];
    // Initialize state
    useEffect(function () {
        if (optionPlan) {
            setName(String(optionPlan.name));
            setPurchasePrice(String(optionPlan.purchasePrice));
            setExercisePrice(String(optionPlan.exercisePrice));
        }
    }, [optionPlan]);
    // GraphQL mutation
    var updateOptionPlan = useUpdateOptionPlanMutation({
        variables: {
            input: {
                optionPlanId: optionPlanId,
                name: name.trim(),
                exercisePrice: Number(exercisePrice),
                purchasePrice: Number(purchasePrice),
            },
        },
    })[0];
    var disabled = !name ||
        (name && regEx.trimmedString.test(name.trim())) === false ||
        name.trim().length < 1 ||
        name.trim().length > 100 ||
        Number(purchasePrice) < 0 ||
        Number(purchasePrice) > 1000000000000 ||
        Number(exercisePrice) < 0 ||
        Number(exercisePrice) > 1000000000000;
    if (loading) {
        return (_jsxs(_Fragment, { children: [_jsx(Toolbar, {}, void 0),
                _jsx(Loading, {}, void 0)] }, void 0));
    }
    if (!optionPlan) {
        throw new Error('Update option plan query failed (option plan not found)');
    }
    return (_jsxs(_Fragment, { children: [_jsx(Toolbar, __assign({ disabled: disabled, onClick: updateOptionPlan }, { children: optionPlan.shareClass.organization.name }), void 0),
            _jsx(Body, { children: _jsxs(List, { children: [_jsx(ListItemInput, { labelWidth: 140, type: "text", label: "Name", value: name, onChange: setName }, void 0),
                        _jsx(ListItemCurrencyInput, { labelWidth: 140, label: "Purchase Price", value: purchasePrice, onChange: setPurchasePrice }, void 0),
                        _jsx(ListItemCurrencyInput, { labelWidth: 140, label: "Exercise Price", value: exercisePrice, onChange: setExercisePrice }, void 0)] }, void 0) }, void 0)] }, void 0));
}
//# sourceMappingURL=UpdateOptionPlan.js.map